import {
  type I18nDictionary,
  type I18nLanguage,
  type I18nNamespace,
  type I18nResourceNamespaces,
  type I18nResources,
  SUPPORTED_I18N_LANGUAGES,
} from './types';

type MergeableI18nResources = {
  [Language in I18nLanguage]: Partial<Record<I18nNamespace, I18nDictionary>>;
};

export const mergeI18nResources = <ResourcesToMerge extends readonly MergeableI18nResources[]>(
  ...resourcesToMerge: ResourcesToMerge
): I18nResources<I18nResourceNamespaces<ResourcesToMerge[number]>> => {
  const mergedResources = SUPPORTED_I18N_LANGUAGES.reduce<
    I18nResources<I18nResourceNamespaces<ResourcesToMerge[number]>>
  >(
    (accumulator, language) => ({
      ...accumulator,
      [language]: {},
    }),
    {} as I18nResources<I18nResourceNamespaces<ResourcesToMerge[number]>>
  );

  for (const currentResources of resourcesToMerge) {
    for (const language of SUPPORTED_I18N_LANGUAGES) {
      mergedResources[language] = {
        ...mergedResources[language],
        ...currentResources[language],
      };
    }
  }

  return mergedResources as I18nResources<I18nResourceNamespaces<ResourcesToMerge[number]>>;
};
